"use strict";
exports.__esModule = true;
exports.chunk = exports.weekDayNames = exports.fa = exports.daysInMonthFa = exports.daysInMonthEn = void 0;
var week_day_1 = require("./week-day");
exports.fa = week_day_1.fa;
exports.weekDayNames = week_day_1.weekDayNames;
var chunk_1 = require("./chunk");
exports.chunk = chunk_1.chunk;
var days_in_month_en_1 = require("./days-in-month.en");
exports.daysInMonthEn = days_in_month_en_1.daysInMonthEn;
var days_in_month_fa_1 = require("./days-in-month.fa");
exports.daysInMonthFa = days_in_month_fa_1.daysInMonthFa;
//# sourceMappingURL=index.js.map